export default "__VITE_ASSET__B1s9OyyR__"